import { useQuery } from '@tanstack/react-query';
import type { BriefParkingLot } from '../../models/parking-contract.ts';
import { fetchBriefParkingLots } from '../../api/partner.ts';

export default function useBriefParkingLots(partnerId: string) {
  const response = useQuery<{ data: BriefParkingLot[] }>({
    queryKey: ['partner', partnerId, 'briefParkingLots'],
    queryFn: () => fetchBriefParkingLots(partnerId),
  });
  const { data, ...rest } = response;
  return { briefParkingLots: data?.data, ...rest };
}
